/* VEYN Alphalete UX: wishlist heart, color-swatch swap, Men's/Women's toggle.
   All delegated on document so it works for lazy-loaded / multiple instances. */
(function () {
  function markWishlist() {
    var w = [];
    try { w = JSON.parse(localStorage.getItem('veyn_wish') || '[]'); } catch (e) {}
    document.querySelectorAll('.alpha-card__heart').forEach(function (h) {
      if (w.indexOf(h.getAttribute('data-id')) > -1) h.classList.add('is-active');
    });
  }
  if (document.readyState !== 'loading') markWishlist();
  else document.addEventListener('DOMContentLoaded', markWishlist);

  document.addEventListener('click', function (e) {
    // Wishlist heart
    var heart = e.target.closest && e.target.closest('.alpha-card__heart');
    if (heart) {
      e.preventDefault(); e.stopPropagation();
      var id = heart.getAttribute('data-id');
      var w = [];
      try { w = JSON.parse(localStorage.getItem('veyn_wish') || '[]'); } catch (er) {}
      var i = w.indexOf(id);
      if (i > -1) { w.splice(i, 1); heart.classList.remove('is-active'); }
      else { w.push(id); heart.classList.add('is-active'); }
      localStorage.setItem('veyn_wish', JSON.stringify(w));
      return;
    }
    // Colour swatch -> swap image, link, colour name
    var sw = e.target.closest && e.target.closest('.alpha-card__swatch');
    if (sw) {
      e.preventDefault(); e.stopPropagation();
      var card = sw.closest('.alpha-card');
      if (!card) return;
      card.querySelectorAll('.alpha-card__swatch').forEach(function (x) { x.classList.toggle('is-active', x === sw); });
      var img = card.querySelector('.alpha-card__img--main');
      if (img && sw.getAttribute('data-img')) { img.setAttribute('srcset', ''); img.src = sw.getAttribute('data-img'); }
      var href = sw.getAttribute('data-href');
      if (href) card.querySelectorAll('a[href]').forEach(function (a) { a.href = href; });
      var cn = card.querySelector('.alpha-card__color');
      if (cn && sw.getAttribute('data-color')) cn.textContent = sw.getAttribute('data-color');
      return;
    }
    // Men's / Women's toggle
    var btn = e.target.closest && e.target.closest('.alpha-toggle__btn');
    if (btn) {
      var wrap = btn.closest('.shopify-section') || document;
      wrap.querySelectorAll('.alpha-toggle__btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      var id = btn.getAttribute('data-target');
      wrap.querySelectorAll('.alpha-toggle-panel').forEach(function (p) { p.hidden = (p.id !== id); });
      return;
    }
  });
})();
